import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { PRODUCT } from "@/constants/product";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const Footer = () => {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await axios.post(`${API}/subscribe`, { email });
      toast.success("You're on the list.");
      setEmail("");
    } catch {
      toast.error("Please enter a valid email.");
    } finally {
      setBusy(false);
    }
  };
  return (
    <footer className="bg-[var(--ink)] text-[var(--paper)]" data-testid="footer">
      <div className="mx-auto grid max-w-7xl gap-10 px-5 py-16 sm:px-8 md:grid-cols-2 md:items-end">
        <div>
          <h2 className="font-display text-3xl">Weekly kitchen notes</h2>
          <p className="mt-3 max-w-md text-zinc-300">Get simple meal planning and grocery budget tips by email.</p>
        </div>
        <form onSubmit={submit} className="flex flex-col gap-3 sm:flex-row">
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@email.com" className="flex-1 rounded-full border border-white/25 bg-transparent px-5 py-3 text-sm outline-none placeholder:text-zinc-400 focus:border-[var(--sage)]" data-testid="newsletter-email-input" />
          <button disabled={busy} className="rounded-full bg-[var(--sage)] px-6 py-3 text-sm font-semibold text-[var(--ink)] transition-transform hover:-translate-y-0.5 disabled:opacity-60" data-testid="newsletter-submit-button">Subscribe</button>
        </form>
      </div>
      <div className="mx-auto flex max-w-7xl flex-col justify-between gap-2 border-t border-white/15 px-5 py-6 text-xs text-zinc-400 sm:flex-row sm:px-8">
        <span>© 2026 {PRODUCT.brand}. All rights reserved.</span>
        <span>{PRODUCT.title}</span>
      </div>
    </footer>
  );
};
